import { render, staticRenderFns } from "./MaterialSymbol.vue?vue&type=template&id=028f5eb8&"
import script from "./MaterialSymbol.vue?vue&type=script&lang=ts&"
export * from "./MaterialSymbol.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialSymbol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports